import React, { useEffect, useState } from 'react'
import AdminServiceV2 from '../../../../services/admin.service.v2';
import { Button, Form, Table } from 'react-bootstrap';
import Select from "react-select"
import toast from 'react-hot-toast';

interface IMhcetMapping {
    examId: any
    exam: any
}

export default function MhcetDBSSyncing(props: IMhcetMapping) {
    const [shiftOptions, setShiftOptions] = useState<any[]>([]);
    const [selectedShift, setSelectedShift] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [shiftExport, setShiftExport] = useState<any>({});

    const getShiftExport = async () => {
        if (!selectedShift) return;
        setLoading(true);
        setShiftExport({});
        try {
            const res = await AdminServiceV2.getShiftExport(selectedShift.value);
            if (res.status === 200) {
                setShiftExport(res.data?.data);
            }
        } catch (e) {
            console.error(e);
            toast.error("No shift export found");
        } finally {
            setLoading(false);
        }
    };

    async function startSync() {
        if (!selectedShift) {
            toast.error("Please select a shift");
            return;
        }

        setLoading(true);
        await AdminServiceV2.startSync(props.examId, selectedShift.value)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Sync started successfully");
                    getShiftExport();
                }
            })
            .catch((err) => {
                toast.error("Failed to start sync");
            })
            .finally(() => {
                setLoading(false);
            });

    }

    useEffect(() => {
        if (props.exam) {
            setShiftOptions(props.exam.shifts.map((s: any) => ({
                label: s.shiftName,
                value: s._id,
                raw: s
            })));
        }
    }, [props.exam]);

    useEffect(() => {
        getShiftExport();
    }, [selectedShift]);

    return (
        <div className="p-3">
            <div className="d-flex gap-3 align-items-end mb-4">
                <Form.Group style={{ flex: 1 }}>
                    <Form.Label>Exam Shift</Form.Label>
                    <Select
                        options={shiftOptions}
                        value={selectedShift}
                        onChange={setSelectedShift}
                        placeholder="Select exam shift..."
                        isClearable
                    />
                </Form.Group>

                <div className="d-flex gap-2 mb-1">
                    <Button
                        onClick={startSync}
                        disabled={!selectedShift}
                    >
                        {
                            loading ? "Syncing..." : "Start DBS Sync"
                        }
                    </Button>
                </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6>Shift Progess</h6>
                <Button
                    onClick={getShiftExport}
                    disabled={!selectedShift}
                    size='sm'
                >
                    Refresh
                </Button>
            </div>
            {loading ? (
                <p className="text-muted">Loading...</p>
            ) : (
                <Table bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>Shift</th>
                            <th>Progress</th>
                            <th>Processed</th>
                            <th>Failed</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{selectedShift?.label || "-"}</td>
                            <td>{shiftExport?.progress || "-"}</td>
                            <td>{shiftExport?.processedUserIds || "-"}</td>
                            <td>{shiftExport?.failedUserIds || "-"}</td>
                        </tr>
                    </tbody>
                </Table>
            )}
        </div>
    );
}
